import React from 'react';
import './HorizontalCarousel.css'; // Importamos los estilos específicos para el carrusel
import ImageWithLoader from './ImageWithLoader';
import { TipoReceta } from '../interfaces/TipoReceta.interface';

const herdezLogo = require('../assets/img/herdez-logo.png');

interface HorizontalCarouselProps {
  items: TipoReceta[]; // Define que items es un array de TipoReceta
  onItemClick: (id: string) => void; // Prop para manejar el clic en el item
}

const HorizontalCarousel: React.FC<HorizontalCarouselProps> = ({ items, onItemClick }) => {
  return (
    <div className="horizontal-carousel">
      {items && items.length > 0 && items.map((item, index) => (
        <div
          key={index}
          className="horizontal-carousel-item"
          onClick={() => onItemClick(item.id)} // Llama a onItemClick al hacer clic
        >
          <ImageWithLoader
            src={item.imagen} // Imagen a cargar
            alt={`item-${index}`}
            className="horizontal-item-image"
            placeholder={herdezLogo}
            loader={undefined}
          />
          <div className="horizontal-item-text">{item.nombre}</div>
        </div>
      ))}
    </div>
  );
};

export default HorizontalCarousel;
